import React, { useState, useEffect} from "react";
import ISubCategory from "../../menu/categories/ISubCategory";
import { useTranslation } from "react-i18next";
import IMenuItemBody from "../../../interfaces/IMenuItemBody";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ListLoading from "../../util/Loading";
import { IMenuData } from "../types";
import { HTTPMethods } from "../../../services/API";
import { ICallAPIFunction } from "../../../yoello-lib/modules/API2/types";
import { ReactComponent as RightPointerSVG } from '../../../assets/images/icon-right-pointer.svg'
import MessageModal, { IMessageModal } from "../../../yoello-lib/modules/components/UI/MessageModal/MessageModal";
import { PRODUCTS_MANAGE_MENU_URL } from "../../../const/URL.const";
import AdvancedChecklist from "../../../yoello-lib/modules/components/UI/Lists/AdvancedChecklist";
import { FilterOptionsType } from "../../../yoello-lib/modules/components/UI/Lists/AdvancedChecklist/state/AdvancedChecklist.actions";

const useStyles = makeStyles((theme: any) =>
    createStyles({
        root: {
            // width: "70rem",
            "@media (max-width: 1100px)": {
                width: "auto",

            },
        },
        content: {
            display: "flex",
            justifyContent: "center",
            alignItems: "stretch",
            fontSize: "1rem",
            color: "#8D98B7",
            marginBottom: "3.5rem",
            flexDirection: "row",
            "@media (max-width: 1100px)": {
                flexDirection: "column",
                "& >div": {
                    width:"100%!important",
                }

            },
            "& >div": {
                width:"28.125rem",
                "& >p": {
                    color: "#424242",
                    fontSize: "1rem",
                }
            }
        },
        tableWrapper: {
            border: "1px solid #E8EAF4",
            borderRadius: "10px",
            padding: "1.125rem 1.25rem",
            height:"fit-content",
            "& >div >div:last-child":{
                minWidth:"unset!important"
            }
        },
        hasError: {
            "&>p": {
                color: "#E90000 !important",
            },
            "& >div": {
                border: '1px solid #E90000'
            }
        },
        middlePointer: {
            width:"unset!important",
            margin: "0 2.5rem",
            display: "flex",
            alignItems: "center",
            "@media (max-width: 1100px)": {
                margin: "1.5625rem 0",

            },
            "& >svg": {
                margin: "auto",
                "@media (max-width: 1100px)": {
                    transform: "rotate(90deg)",

                },
            }
        },
        footer: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "1.25rem 3.5rem",
            boxShadow: "0px 0px 20px rgba(33, 33, 33, 0.1)",
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            zIndex: 999,
            "@media (max-width: 1100px)": {
                padding: "1.25rem 1.5rem",
            },
        },
        CancelButton: {
            background: "#F3F4F9",
            borderRadius: "8px",
            color: "#212121",
            fontSize: "0.9375rem",
            padding: "0.875rem 1.5625rem",
            "&:hover": {
                cursor: "pointer"
            }
        },
        SubmitButton: {
            background: "#FFDD02",
            borderRadius: "8px",
            color: "#212121",
            fontSize: "0.9375rem",
            fontWeight: 600,
            padding: "0.875rem 1.5625rem",
            marginLeft: "2rem",
            "&:hover": {
                cursor: "pointer"
            }
        }
    }),
);



interface IAddItemToMenuDialog {
    menuItems: IMenuItemBody[];
    venueId: string;
    onClose: () => void;
    subcategories: ISubCategory[];
    orphanedMenuItemsAPI: ICallAPIFunction<any>;
    manageMenuAPI: ICallAPIFunction<any>;
    history: any;
    updateData?: (updatedItems: IMenuItemBody[], updatedMenus?: IMenuData[]) => void;

}
export function AddItemsToMenuDialog({
    menuItems,
    venueId,
    onClose,
    subcategories,
    orphanedMenuItemsAPI,
    manageMenuAPI,
    history,
    updateData
}: IAddItemToMenuDialog) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [loadingText, setLoadingText] = useState<string>(t("manageMenu.form.loadingItemsText"))
    const [menusList, setMenusList] = useState<IMenuData[]>([])
    const [itemsList, setItemsList] = useState<IMenuItemBody[]>([])
    const [selectedMenus, setSelectedMenus] = useState<IMenuData[]>([])
    const [selectedItems, setSelectedItems] = useState<IMenuItemBody[]>([])
    const [messageModalData, setMessageModalData] = useState<IMessageModal | null>(null)
    const [error, setError] = useState<boolean>(false)
    const [resetSelectedMenus, setResetSelectedMenus] = useState<boolean>(false)


    const filterOptions: FilterOptionsType[] = [{
        label: t("misc.subcategory"),
        optionLabelKey: "subcategory_name",
        optionFilterKey: "id",
        itemFilterKey: "subcategory_id",
        filterOptionsList:subcategories || [],
    }];

    useEffect(() => {
        setItemsList(menuItems)

        manageMenuAPI(HTTPMethods.GET, {
            query: "?venue_id=" + venueId
        }).then(res => {
            setMenusList(res.data)
            setIsLoading(false)
            setLoadingText("")
        })
        // eslint-disable-next-line
    }, [])

    function menusOnChange(selected: IMenuData[]) {
        setSelectedMenus(selected)
    }

    function itemsOnChange(selected: IMenuItemBody[]) {
        setSelectedItems(selected)
    }

    async function onSubmit() {
        if (selectedItems.length === 0 || selectedMenus.length === 0) {
            setError(true)

            if (window.innerWidth < 1100) {
                const element = document.getElementById(selectedItems.length === 0 ? "ItemsWrapperID" : "MenusWrapperID");
                element?.scrollIntoView({
                    behavior: "smooth",
                })
            }
            return;
        }
        setError(false)
        setIsLoading(true)
        setLoadingText(t("manageMenu.form.AddingItemsToMenu"))
        const selectedItemsIDs = selectedItems.map(item => item.id)
        await manageMenuAPI(HTTPMethods.PATCH, {
            body: selectedMenus.map(item => {
                return {
                    "menu_id": item.id,
                    "menu_items": {
                        "append": selectedItemsIDs,
                        "remove": []
                    }
                }
            })
        }).then(async (res) => {
            await orphanedMenuItemsAPI(HTTPMethods.GET).then(res => {
                setItemsList(res.data)
                if (updateData) {
                    updateData(res.data as unknown as IMenuItemBody[])
                }
            })
            setMessageModalData({
                status: "success",
                message: t("manageMenu.form.AddItemsSuccessMessage"),
                ButtonOneText: t("manageMenu.buttons.AssignMoreItems"),
                ButtonTwoText: t("manageMenu.buttons.GoToMenus"),
                onButtonOneClick: () => {
                    setSelectedItems([])
                    setSelectedMenus([])
                    setMessageModalData(null)
                    setTimeout(() => {
                        // Timeout to let the component render first
                        setResetSelectedMenus(!resetSelectedMenus)
                    }, 200);
                },
                onButtonTwoClick: () => {
                    onClose()
                    setTimeout(() => {
                        history.push(PRODUCTS_MANAGE_MENU_URL)
                    }, 350);

                },
            })
        }).catch(e => {
            setMessageModalData({
                status: "error",
                message: t("manageMenu.form.AddItemsErrorMessage"),
                ButtonOneText: t("manageMenu.buttons.GoBack"),
                onButtonOneClick: () => setMessageModalData(null),
            })
        })
        setIsLoading(false)
        setLoadingText("")

    }


    const classes = useStyles();
    if (isLoading) {
        return <ListLoading secondaryText={loadingText} />
    } else if (messageModalData) {
        return <MessageModal {...messageModalData} />
    } else {
        return <div className={classes.root}>
            <div className={classes.content}>
                <div className={error && selectedItems.length === 0 ? classes.hasError : ''} id="ItemsWrapperID">
                    <p>{t("manageMenu.form.SelectItemsToAdd")}</p>
                    <div className={classes.tableWrapper} >
                        <AdvancedChecklist 
                            listData={itemsList}
                            mainLabelKey={"name_public"}
                            onItemSelectionChange={itemsOnChange}
                            filterOptions={filterOptions}
                            isVirtualizeList={true}
                        />
                    </div>

                </div>
                <div className={classes.middlePointer}>
                    <RightPointerSVG width="20px" height="20px" />
                </div>
                <div className={error && selectedMenus.length === 0 ? classes.hasError : ''} id="MenusWrapperID">
                    <p>{t("manageMenu.form.SelectMenusToBeAdded")}</p>
                    <div className={classes.tableWrapper} >
                        <AdvancedChecklist
                            listData={menusList}
                            mainLabelKey="name_public"
                            onItemSelectionChange={menusOnChange}
                        />
                    </div>

                </div>
            </div>



            <div className={classes.footer}>
                <div className={classes.CancelButton} onClick={onClose}>
                    {t("manageMenu.buttons.cancel")}
                </div>
                <div className={classes.SubmitButton} onClick={onSubmit}>
                    {t("manageMenu.buttons.AddItemsToMenu", {
                        itemsCount: selectedItems.length > 0 ? selectedItems.length : "",
                        menusCount: selectedMenus.length > 0 ? selectedMenus.length : ""
                    })}
                </div>
            </div>

        </div>
    }

}